import { reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { AuthenticationRequest } from "./types";

export const useLogin = (authFunction: AuthenticationRequest) => {

    const { t } = useI18n();

    const isLoginRequestRunning = ref(false);
    const alertMessage = reactive({
        header: '',
        body: ''
    });


    const loginData = reactive({
        emailAddress: '',
        password: '',
        save: true,
    });

    const resetLoginData = () => {
        alertMessage.header = '';
        alertMessage.body = '';
        loginData.emailAddress = '';
        loginData.password = '';
    };

    const login = async () => {

        try {
            if (!loginData.emailAddress || !loginData.password) {
                alertMessage.header = t("alert.missingDataHead");
                alertMessage.body = t("alert.missingDataText");
                return;
            }

            isLoginRequestRunning.value = true;

            return authFunction({
                identifier: loginData.emailAddress,
                password: loginData.password
            });

        } catch (err: any) {
            isLoginRequestRunning.value = false;
            if (err.status === 'Network Error') {
                alertMessage.header = t("alert.noConnectionHead");
                alertMessage.body = t("alert.noConnectionText");
            } else if (err.response?.status === 400) {
                alertMessage.header = t("alert.loginErrorHead");
                alertMessage.body = t("alert.loginErrorText");
                loginData.password = '';
            } else {
                alertMessage.header = t("alert.unexpectedErrorHead");
                alertMessage.body = t("alert.unexpectedErrorText");
            }

            return {
                loginFailed: true
            };
        } finally {
            isLoginRequestRunning.value = false;
        }
    };

    return {
        isLoginRequestRunning,
        login,
        loginData,
        alertMessage,
        resetLoginData
    };
};